import { render } from "./WorkflowStepCard.vue?vue&type=template&id=068220ca"
import script from "./WorkflowStepCard.vue?vue&type=script&lang=ts"
export * from "./WorkflowStepCard.vue?vue&type=script&lang=ts"
script.render = render

export default script